module.exports = __webpack_public_path__ + "static/media/google_01.6c07fac8.svg";